import React from "react";

import { Link } from "react-router-dom";

export default function Header({
  compact,
  className,
}: {
  compact?: boolean;
  className?: string;
}) {
  return (
    <>
      <header
        className={
          (compact ? "compact" : "full") + ` ${className ? className : ""}`
        }
      >
        <Link to="/">
          <img src="/assets/img/logo_150x150.png" alt="Contempas" />
        </Link>
      </header>
    </>
  );
}
